import IframeActivity from "./IframeActivity";

export default function WhereDidILeaveIt() {
    return (
        <IframeActivity
            src="/activities/where-did-i-leave-it/index.html"
            title="Where Did I Leave It?"
        />
    );
}